export function getWordByNumber(number: number, words: string[]) {
	const absValue = Math.abs(number);
	const match = absValue.toString().split('.')?.[1]?.match(/[1-9]/g);
	const fractional = match?.[match?.length - 1];

	const value = fractional ? +fractional : absValue;

	return words[
		value % 100 > 4 && value % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][value % 10 < 5 ? value % 10 : 5]
	];
}

export function formatNumber(value: string | number, decimalLength: number = 2): string {
	const parsedVal = parseFloat(value?.toString());

	return new Intl.NumberFormat('ru-RU', {
		maximumFractionDigits: decimalLength,
	}).format(parsedVal);
}
